export const removeOptionalKeysSuffix = (
  obj: Record<string, any>,
  suffix: string,
) =>
  Object.keys(obj).reduce<typeof obj>((acc, key) => {
    acc[key.replace(suffix, ``)] = obj[key];
    return acc;
  }, {});
